import React from 'react';
import { IconButtonStyled } from '@/components/Packaging/VideoPreview/controls/common/IconButtonStyled';
import { IconStyled } from '@/components/Packaging/VideoPreview/controls/common/IconStyled';

interface Props {
  isMuted: boolean;
  onClick(): void;
}

const MuteButton: React.FC<Props> = ({ isMuted, onClick }) => {
  return (
    <IconButtonStyled title={isMuted ? 'Unmute' : 'Mute'} onClick={onClick}>
      <IconStyled icon={isMuted ? 'volume_mute' : 'volume_up'} />
    </IconButtonStyled>
  );
};

export default MuteButton;
